
import { Component, Vue } from 'vue-property-decorator'
import Header from '@/components/componentWap/Header.vue'
import { TabList } from '@/constants'
@Component({
    name: 'Question',
    components: {
        Header
    }
})
export default class extends Vue {
    private tabList = TabList
    private goPage(path: string) {
        this.$jump(path)
    }
}
